<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    :color="color??''"
    :class="$vuetify.breakpoint.smAndDown ? 'pa-4' : 'pa-6'"
    elevation="0"
  >
    <slot />
  </v-card>
</template>

<script>
export default {
  name: 'LargeBaseCard',
  props: {
    color: {}
  }
}
</script>

<style scoped>

</style>
